import { render, staticRenderFns } from "./prize-draw.vue?vue&type=template&id=03258a00&scoped=true"
import script from "./prize-draw.vue?vue&type=script&lang=js"
export * from "./prize-draw.vue?vue&type=script&lang=js"
import style0 from "./prize-draw.vue?vue&type=style&index=0&id=03258a00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03258a00",
  null
  
)

export default component.exports